{
  "title": "Maddening Darkness",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "8th-level evocation",
  "level": 8,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, M (a drop of pitch mixed with a drop of mercury)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Magical darkness spreads from a point you choose within range to fill a 60-foot-radius sphere until the spell ends. The darkness spreads around corners. A creature with darkvision can’t see through this darkness. Nonmagical light, as well as light created by spells of 8th level or lower, can't illuminate the area. Shrieks, gibbering, and mad laughter can be heard within the sphere. Whenever a creature starts its turn in the sphere, it must make a Wisdom saving throw, taking 8d8 psychic damage on a failed save, or half as much damage on a successful one."
  ],
  "spellLists": ["warlock", "wizard"]
}
